import {QueryClient, QueryKey} from 'react-query'
import {QUERIES} from './crud-helper/consts'

/**
 * Queries que criar, editar, ajustar tempo, entregar ou excluir uma tarefa não altera. O
 * `invalidateQueries()` sem filtro recarregava também estas (sessão, versão, RushMind, tags,
 * configuração, selects de cadastro) a cada ação: ~70 requisições por tarefa, o limite de 120/min do
 * usuário estourava e ele voltava para o login. Item terminado em '-' vale como prefixo.
 */
const UNAFFECTED_BY_TASK_ACTIONS = [
  'verify-token',
  'system-version',
  'rushmind-availability',
  'rushmind-insight',
  'tags',
  'task-templates-list',
  `${QUERIES.TASKS_LIST}-usersTask`,
  `${QUERIES.PROJECTS_LIST}-config-`,
  `${QUERIES.SELECT_AUTOCOMPLETE_LIST}-`,
]

// O react-query 3 guarda a chave como foi passada: string ('system-version') ou array
// (['verify-token', token]). Indexar uma string pegaria só o primeiro caractere.
const queryName = (queryKey: QueryKey): string =>
  String(Array.isArray(queryKey) ? queryKey[0] : queryKey)

export const isAffectedByTaskAction = (queryKey: QueryKey): boolean => {
  const name = queryName(queryKey)

  return !UNAFFECTED_BY_TASK_ACTIONS.some((unaffected) =>
    unaffected.endsWith('-') ? name.startsWith(unaffected) : name === unaffected
  )
}

/**
 * Depois de uma ação de tarefa: recarrega listas, kanban, calendário e a tarefa, e nada mais. Com
 * `refreshSession`, recarrega também o usuário da sessão: entregar ou excluir a tarefa com o
 * cronômetro rodando para o cronômetro no servidor, e o `has_active_time_tracking` do usuário (título
 * "Tarefa em andamento") só se atualiza pelo `verify-token`.
 */
export const invalidateAfterTaskChange = (
  queryClient: QueryClient,
  {refreshSession = false}: {refreshSession?: boolean} = {}
) =>
  queryClient.invalidateQueries({
    predicate: (query) =>
      isAffectedByTaskAction(query.queryKey) ||
      (refreshSession && queryName(query.queryKey) === 'verify-token'),
  })
